export default __webpack_public_path__ + "static/media/admin-panel.102d2b0b.svg";